import { store } from "../../redux/app/store";
import { setSubscriptionModal } from "../../redux/slices/app/app.slice";

export const handleSubscriptionNotFound = async (response) => {
    const isSubscribed = response?.data?.subscription;
    const service = response?.data?.service;
    const isLead = service === "lead";
    const isLand = service === "landpg";

    if (!isLead && !isLand) return;

    if (!isSubscribed) {
        store.dispatch(setSubscriptionModal(service));
    }
};
